{
  "My learning": "My learning",
  "Learnings": "Learnings",
  "Learning": "Title",
  "Events": "Events",
  "Filter": "Filter",
  "To do": "To do",
  "Assigned": "Assigned",
  "Ongoing": "Ongoing",
  "Saved by me": "Saved",
  "Completed": "Completed",
  "No learnings here yet": "Currently empty",
  "Save to my learning": "Save to my learning",
  "course-completion-delay-info": "Time updates can be delayed up to 72 hours due to technical dependencies",
  "View Campus Online Data": "View your Campus Online data",
  "View all": "View all",
  "On track": "On track",
  "My Role": "My Role",
  "My Role_plural": "My Roles",
  "Type": "Type",
  "Source": "Source",
  "Total Time": "Total Time",
  "Add other learning time": "Add learning time",
  "Update other learning": "Update learning time",
  "completed-singular": "Completed"
}
